var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("ValidationObserver", {
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit }) {
                    return [
                      _c("table", { staticClass: "table table-bordered" }, [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              { staticClass: "title", attrs: { colspan: "4" } },
                              [_vm._v("任用單")]
                            ),
                          ]),
                        ]),
                        _c("tbody", [
                          _c("tr", [
                            _c("td", { staticClass: "width-15 text-right" }, [
                              _vm._v("應聘者"),
                            ]),
                            _c("td", { staticClass: "width-35" }, [
                              _vm._v(
                                " " + _vm._s(_vm.appointmentForm.Name) + " "
                              ),
                            ]),
                            _c("td", { staticClass: "width-15 text-right" }, [
                              _vm._v("聘用類別"),
                            ]),
                            _c("td", { staticClass: "width-35" }, [
                              _vm._v(
                                _vm._s(_vm.appointmentForm.EmployCategory)
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "width-15 text-right" }, [
                              _vm._v("任用部門"),
                            ]),
                            _c("td", { staticClass: "width-35" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.appointmentForm.AppointmentDepartment
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "width-15 text-right" }, [
                              _vm._v("主管承認年資"),
                            ]),
                            _c("td", { staticClass: "width-35" }, [
                              _vm._v(
                                _vm._s(_vm.appointmentForm.AdmitSeniority)
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "width-15 text-right" }, [
                              _vm._v("最高學歷"),
                            ]),
                            _c("td", { staticClass: "width-35" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.appointmentForm.HighestEducation) +
                                  " "
                              ),
                            ]),
                            _c("td", { staticClass: "width-15 text-right" }, [
                              _vm._v("學校 / 科系"),
                            ]),
                            _c("td", { staticClass: "width-35" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.appointmentForm.School) +
                                  " / " +
                                  _vm._s(_vm.appointmentForm.Department) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c(
                              "td",
                              { staticClass: "title", attrs: { colspan: "4" } },
                              [_vm._v("任用建議")]
                            ),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v("職務"),
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.appointmentForm.PositionName)),
                            ]),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v("職等"),
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.appointmentForm.Rank)),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v("試用期薪資"),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.appointmentForm.ProbationPeriodSalary
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v("正式薪資"),
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.appointmentForm.Salary)),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v("其他特殊說明"),
                              _c("br"),
                              _vm._v("(含試用期說明)"),
                            ]),
                            _c("td", { attrs: { colspan: "3" } }, [
                              _vm._v(_vm._s(_vm.appointmentForm.Description)),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v("任用結果"),
                            ]),
                            _c("td", { attrs: { colspan: "3" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.appointmentForm.ApprovalResult) +
                                  " "
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "button-wrap center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary mr-1",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.back()
                              },
                            },
                          },
                          [_vm._v(" 返回 ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-danger mr-1",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                handleSubmit(_vm.sendReviewResult("否決"))
                              },
                            },
                          },
                          [_vm._v(" 否決 ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-success mr-1",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                handleSubmit(_vm.sendReviewResult("通過"))
                              },
                            },
                          },
                          [_vm._v(" 同意 ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.openChoiceSupervisorModal("已簽核")
                              },
                            },
                          },
                          [_vm._v(" 加簽 ")]
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "choiceSupervisorModal",
            tabindex: "-1",
            "aria-hidden": "true",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("ValidationObserver", {
                  ref: "choiceSupervisor",
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ handleSubmit, reset }) {
                        return [
                          _c(
                            "form",
                            {
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return handleSubmit(_vm.sendSupervisor)
                                },
                                reset: function ($event) {
                                  $event.preventDefault()
                                  return reset.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "modal-header" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "modal-title",
                                    attrs: { id: "exampleModalCenterTitle" },
                                  },
                                  [_vm._v(" 選擇人員 ")]
                                ),
                              ]),
                              _c("div", { staticClass: "modal-body" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("簽核人員"),
                                    ]),
                                    _c("ValidationProvider", {
                                      staticClass: "w-100",
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("v-select", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    options:
                                                      _vm.supervisorOptions,
                                                    label: "Name",
                                                    placeholder: "請選擇",
                                                    reduce: (
                                                      choiceSupervisor
                                                    ) => choiceSupervisor.Guid,
                                                  },
                                                  model: {
                                                    value: _vm.choiceSupervisor,
                                                    callback: function ($$v) {
                                                      _vm.choiceSupervisor = $$v
                                                    },
                                                    expression:
                                                      "choiceSupervisor",
                                                  },
                                                }),
                                                errors[0]
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c("img", {
                                  staticClass: "job-position",
                                  attrs: {
                                    src: require("@/assets/img/query.png"),
                                    alt: "",
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "modal-footer" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "button",
                                      "data-dismiss": "modal",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.i18n("Buttons.Close")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: { type: "submit" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.i18n("Buttons.Confirm")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }